// react
import { useContext } from 'react';

// context
import { ContextBeneficiary, ContextBeneficiaryUsers } from '../Beneficiary.context';

// mui
import { Container } from '@mui/material';

// tables
import { TableUsers } from '../../../tables/cards/TableUsers/TableUsers';

export const Users = () => {
	// context
	const { beneficiary } = useContext(ContextBeneficiary);
	const { isLoadingUsers, paginationUsers, refetchUsers, users } =
		useContext(ContextBeneficiaryUsers);

	return (
		<section>
			<Container maxWidth={false}>
				<TableUsers
					entity={beneficiary}
					frame="BENEFICIARY"
					isLoading={isLoadingUsers}
					pagination={paginationUsers}
					refetchUsers={refetchUsers}
					users={users}
				/>
			</Container>
		</section>
	);
};
